module.exports = __webpack_public_path__ + "static/media/4.cbe631d5.jpg";